module.exports = __webpack_public_path__ + "img/核心技术-3d贴纸.5388b505.gif";